<div class="container-fluid">
    <div class="row">
        <app-history-view [title]="sectionTitle" [data]="noteData" [commentQty]="data.comments?.length"
                          [alias]="config.alias"
                          (reviewAction)="handleReviewAction($event)"></app-history-view>
    </div>
    <ng-container *jargonViewMode="'notes:write'">
        <div class="row my-2">
            <app-expandable-textarea class="p-0"
                                     [title]="sectionTitle"
                                     [placeholder]="'Start typing or drag a builder here...'"
                                     [formControl]="note"
                                     jargonLoadingState="builder-control"
                                     (saveEvent)="saveNotes($event)">
            </app-expandable-textarea>
        </div>
    </ng-container>
</div>